// extracted by mini-css-extract-plugin
module.exports = {"details":"OrdersByIBONew_details__IP_Qz","iboListItem":"OrdersByIBONew_iboListItem__2JIyh","noSelection":"OrdersByIBONew_noSelection__TBnId"};